import { useState } from 'react'
import { useLayoutV3State } from 'hooks/useLayoutV3State'
import { StaticSummary } from '../StaticSummary/StaticSummary'
import { SummaryS } from '../StaticSummary/SummaryS'
import { Icon } from '../StaticSummary/Icon'
import { ContentSwitcherBySkin } from 'components/Atoms/ContentSwitcherBySkin'
import { YoloStaticLeftContent } from './YoloAnnouncements'
import { SKINS } from 'constants/skins'
import { icons } from 'common'
// import { PanelSection } from 'components/Organisms/PanelSection'
import styled, { css } from 'styled-components'
import { PanelSection } from 'components/Molecules/PanelSection'

const ANNOUNCEMENTS_BY_SKIN = {
  [SKINS.WSB]: null,
  [SKINS.DEFAULT]: <YoloStaticLeftContent />,
}

export const AnnouncementLeftPanelSection = () => {
  const [hideSection, setHideSection] = useState(false)

  if (hideSection) return null
  return (
    // <PanelSection
    //   className='announcementSection'
    //   key='announcementSection'
    //   icon={icons.events_icon_white}
    //   title='ANNOUNCEMENTS'
    //   initOpen={true}
    //   // forceOpen={true}
    //   cover={true}
    // >
    <ContentSwitcherBySkin
      noWrapper
      onChildrenNull={(isNull) => setHideSection(isNull)}
      componentsBySkin={ANNOUNCEMENTS_BY_SKIN}
    />
    // </PanelSection>
  )
}
